<template src="./html/Show.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Navbar from './Navbar'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'navbar': Navbar,
		},
		data () {
			return {
				data: null,
			}
		},
		created () {
			this.init()
		},
		watch: {
			'$route': function () {
				this.data = null
				this.getData()
			},
		},
		methods: {
			init() {
				this.getData()
			},
			reloadData() {
				this.getData()
			},
			getData() {
				this.$http.get('admin/management/orders/' + this.$route.params.id)
				.then(response => {
					this.data = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			generateOrderProvider(product) {
				if(this.data.providers) {
					if(this.data.providers.length) {
						var provider = this.data.providers.find(function(provider) {
							return provider.id == product.provider_id
						})
						if(provider) {
							var hasOrder = false
							if(provider.orders) {
								if(provider.orders.length) {
									hasOrder = true
								}
							}
							if(hasOrder) {
								this.$refs.Navbar.openGenerateOrderProvider(product, provider)
							} else {
								var that = this
								swal.queue([{
									title: that.$t("messages.attention"),
									text: that.$t("messages.purchase_order_will_be_added"),
									type: "warning",
									showCancelButton: true,
									confirmButtonColor: "#53e69d",
									cancelButtonColor: "#ff7676",
									confirmButtonText: "Si",
									cancelButtonText: "No",
									showLoaderOnConfirm: true,
									preConfirm: function () {
										var data = {
											tax_id: that.data.tax_id,
											currency_id: that.data.currency_id,
											lang_id: that.data.lang_id,
											parent_id: that.data.id,
											provider_id: provider.id,
											products: [
												product,
											]
										}
										return new Promise(function (resolve) {
											that.$http.post('admin/management/orders', data)
											.then(response => {
												that.reloadData()
												swal(response.body.title, response.body.text, response.body.type);
											}).catch(function(response) {
												if(response.status == 409) {
													swal(response.body.title, response.body.text, response.body.type);
												} else {
													swal({
														title: response.statusText,
														text: response.body,
														type: "warning"
													});
												}
											})
										})
									}
								}]).catch(swal.noop)
							}
						}
					}
				}
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/orders/views/Show.vue